/* Bucket callouts
   Clicking a colour (or the colour card) scrolls smoothly to the Bucket PDP hero and, for a
   colour, selects it there by pressing the hero's matching swatch. Without JS (or with no hero
   on the page) the links behave as normal anchor links. */
(function () {
  'use strict';
  var reduce = window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches;

  function findSwatch(hero, colour) {
    var want = colour.trim().toLowerCase();
    var names = hero.querySelectorAll('.bph__sw-name');
    for (var i = 0; i < names.length; i++) {
      if (names[i].textContent.trim().toLowerCase() === want) return names[i].closest('button');
    }
    return null;
  }

  function onClick(e) {
    var link = e.currentTarget;
    var id = (link.getAttribute('href') || '').replace('#', '');
    var target = (id && document.getElementById(id)) || document.querySelector('[data-bph]');
    if (!target) return; // no hero on this page: let the link behave normally
    e.preventDefault();
    var colour = link.getAttribute('data-bco-colour');
    var swatch = colour ? findSwatch(target, colour) : null;
    if (swatch) swatch.click();
    target.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'start' });
    // Keyboard users land on the colour they picked (or the hero's first swatch).
    var focusEl = swatch || target.querySelector('.bph__sw');
    if (focusEl) focusEl.focus({ preventScroll: true });
  }

  function init(scope) {
    Array.prototype.forEach.call((scope || document).querySelectorAll('[data-bco] [data-bco-link]'), function (link) {
      if (link.dataset.bcoReady) return;
      link.dataset.bcoReady = '1';
      link.addEventListener('click', onClick);
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(); });
  else init();
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
